/**
 * 表格颜色处理 Mixin
 * 用于统一处理表格中数值的颜色显示
 * 负数显示为绿色(success-color)，正数显示为红色(danger-color)，0不处理
 */
export const tableColorMixin = {
    methods: {
    /**
     * 设置表格数值颜色
     * @param {string|number} value - 需要处理的值，可能是 "-10%"、"-10"、"10"、0 等
     * @returns {string} - 返回对应的CSS类名
     */
        setColor(value) {
            // 如果值为空或未定义，返回空字符串
            if (value === null || value === undefined || value === '') {
                return '';
            }

            // 转换为字符串进行处理
            const strValue = String(value).trim();

            // 如果是空字符串，返回空
            if (strValue === '') {
                return '';
            }

            // 去除百分号，获取数值部分
            const numericValue = strValue.replace('%', '');

            // 转换为数字
            const num = parseFloat(numericValue);

            // 如果不是有效数字，返回空字符串
            if (isNaN(num)) {
                return '';
            }

            // 0 不处理，返回空字符串
            if (num === 0) {
                return '';
            }

            // 负数返回绿色(success-color)，正数返回红色(danger-color)
            return num < 0 ? 'danger-color' : 'success-color';
        },

        /**
     * 获取带颜色样式的值对象
     * 可用于 el-table-column 的 formatter 或在模板中使用
     * @param {string|number} value - 需要处理的值
     * @returns {object} - 返回包含值和样式类的对象
     */
        getColorValue(value) {
            return {
                value: value,
                className: this.setColor(value)
            };
        }
    }
};

export default tableColorMixin;
